export const AUTH_QUERY_KEYS = {
  all: ['auth'],
  userProfile: ['auth', 'userProfile'],
} as const
export const DASHBOARD_QUERY_KEYS = {
  all: ['dashboard'],
  stats: ['dashboard', 'stats'],
} as const

export const USER_QUERY_KEYS = {
  all: ['users'] as const,
  profile: () => [...USER_QUERY_KEYS.all, 'profile'] as const,
  users: () => [...USER_QUERY_KEYS.all, 'list'] as const,
  roles: () => ['roles'] as const,
  byId: (id: string) => ['user', id] as const,
  userStatistics: ['userStatistics'] as const,
  statistics: () => ['statistics'] as const,
  userDetails: (id: string) => ['userDetails', id] as const,
  userActivity: (page: number) => ['userActivity', page] as const,
  userAttendedEvents: ['userAttendedEvents'] as const,
}

export const EVENT_QUERY_KEYS = {
  all: ['events'],
  categories: ['categories'],
  byId: (id: string) => ['event', id] as const,
  eventStatistics: ['eventStatistics'] as const,
} as const

export const CATEGORY_QUERY_KEYS = {
  all: ['category'],
}

export const TAG_QUERY_KEYS = {
  all: ['tag'],
}

export const ATTENDEE_QUERY_KEYS = {
  all: ['attendees'],
  attendee_bookings: ['attendee_bookings'],
  byId: (id: string) => ['attendee', id] as const,
  eventAdminStatistics: ['eventAdminStatistics'] as const,
} as const

export const ATTENDEE_PAYMENT_STATUS_QUERY_KEYS = {
  paymentStatus: (transactionId: string) =>
    ['paymentStatus', transactionId] as const,
}

export const SPONSOR_QUERY_KEYS = {
  allEvents: ['sponsor-events'],
  mainEvent: ['main-events'],
  subEvents: ['sub-events'],
  byId: (id: string) => ['sponsor-event', id] as const,
  sponsorShipPlansById: (id: string) => ['sponsorShip-plans', id] as const,
  allAdPlacementPlans: ['ad-placement-plans'],
  adPlacementTypes: (id: string) => ['ad-placement-types', id] as const,
  advertisementList: ['advertisement-list'] as const,
  availableAdDates: ['available-ad-dates'] as const,
  advertisementById: (id: string) => ['avertisement-detail', id] as const,
  advertisementFrequency: ['advertisement-frequency'] as const,
  demographicsData: ['demographics-data'] as const,
  advertisementStatistics: (source: string) =>
    ['advertisement-statistics', source] as const,
}

export const SUB_EVENT_QUERY_KEYS = {
  allSubEvents: ['sub-events'],
  byId: (id: string) => ['sub-event', id] as const,
  mainEventDates: (id: string) => ['main-event-dates', id] as const,
}
